module.exports = __webpack_public_path__ + "static/img/testimonial-bg2.8768407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial-bg2.png
// module id = KvG4
// module chunks = 36